module.exports = __webpack_public_path__ + "img/APP.7e40b942.png";